import { useState } from "react";
import { Loader2, UploadCloud } from "lucide-react";
import { toast } from "sonner";
import { api, formatError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Checkbox } from "@/components/ui/checkbox";

export default function ScanSelectBar({ files, selected, setSelected, qboConnected, onDone }) {
  const [busy, setBusy] = useState(false);
  const ids = (files || []).map((f) => f.id);
  const n = ids.filter((id) => selected.has(id)).length;
  const all = ids.length > 0 && n === ids.length;

  const send = async () => {
    setBusy(true);
    try {
      const { data } = await api.post("/qbo/attach-scans", { ids: ids.filter((id) => selected.has(id)) });
      const bad = data.results.filter((r) => !r.ok);
      data.sent && toast.success(`${data.sent} scan${data.sent === 1 ? "" : "s"} in QuickBooks${data.results[0]?.to ? ` (${data.results.filter((r) => r.ok).map((r) => r.to).filter((v, i, a) => a.indexOf(v) === i).join(", ")})` : ""}`);
      bad.length && toast.error(`${bad[0].name}: ${bad[0].error}${bad.length > 1 ? ` (+${bad.length - 1} more)` : ""}`);
      setSelected(new Set());
      onDone();
    } catch (e) { toast.error(formatError(e)); }
    setBusy(false);
  };

  if (!ids.length) return null;
  return (
    <div className={`mt-5 flex flex-wrap items-center gap-3 rounded-lg border px-4 py-2 ${n ? "border-primary/40 bg-primary/10" : "bg-card"}`} data-testid="scan-selection-bar">
      <label className="flex items-center gap-2 text-sm cursor-pointer">
        <Checkbox className="data-[state=indeterminate]:bg-primary/40" checked={all ? true : n ? "indeterminate" : false} onCheckedChange={() => setSelected(all ? new Set() : new Set(ids))} data-testid="scan-select-all" />
        {n ? <span data-testid="scan-selected-count">{n} selected</span> : "Select all"}
      </label>
      {n > 0 && <>
        <Button size="sm" variant="outline" onClick={send} disabled={busy || !qboConnected} title={qboConnected ? "" : "Connect QuickBooks in the Admin panel first"} data-testid="scan-send-qbo-button" className="text-emerald-400 hover:bg-emerald-500/10 hover:text-emerald-400">
          {busy ? <Loader2 size={15} className="animate-spin" /> : <UploadCloud size={15} />} Send to QuickBooks
        </Button>
        {!qboConnected && <span className="text-xs text-muted-foreground" data-testid="scan-qbo-not-connected">Connect QuickBooks in the Admin panel to send scans.</span>}
        <Button size="sm" variant="ghost" onClick={() => setSelected(new Set())} data-testid="scan-clear-selection">Clear</Button>
      </>}
    </div>
  );
}
